import React from "react";
import s from "./Sidebar.module.css";
 import { Link } from "react-scroll";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  return (
    <div className={`${s.sidebar} ${isOpen ? s.open : ""}`}>
      <Link onClick={toggleSidebar} to="main" className={s.menuItem}>
        Ana Sayfa
      </Link>
      <Link onClick={toggleSidebar} to="about" className={s.menuItem}>
        Hakkımda
      </Link>
      <Link onClick={toggleSidebar} to="avidef" className={s.menuItem}>
        AVIDEF
      </Link>
      <Link
        offset={-90}
        onClick={toggleSidebar}
        to="timeline"
        className={s.menuItem}
      >
        Tecrübelerim
      </Link>

      <Link onClick={toggleSidebar} to="contact" className={s.menuItem}>
        İletişim
      </Link>
    </div>
  );
};

export default Sidebar;
